import "../css/currentCnt.css";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LOAD_ALLAPPLICATIONS_REQUEST } from "../reducers/adminBusiness";
import {
  LOAD_BUSINESS_REQUEST,
  LOAD_ALLUSER_REQUEST,
} from "../reducers/adminUser";
const CurrentCnt = () => {
  const dispatch = useDispatch();
  const { allUsers, userBusinesses } = useSelector((state) => state.adminUser);
  const { allApplications } = useSelector((state) => state.adminBusiness);
  // 회원 수를 세면서도 정작 회원 목록을 불러오라는 요청이 빠져 있었습니다.
  // 다른 메뉴를 먼저 들르지 않고 이 화면부터 열면 화면이 뜨지 않았습니다.
  const individualCnt =
    allUsers && allUsers.filter((user) => user.userType === "individual").length;
  const businessCnt =
    allUsers && allUsers.filter((user) => user.userType === "business").length;
  const applicationCnt = allApplications && allApplications.length;
  const progressCnt =
    allApplications &&
    allApplications.filter((app) => app.progressStep !== "목록신청전").length;
  const yearCnt =
    userBusinesses &&
    userBusinesses.filter(
      (business) => business.business_member_pay === "250000원"
    ).length;
  const caseCnt =
    userBusinesses &&
    userBusinesses.filter(
      (business) => business.business_member_pay === "200000원"
    ).length;

  useEffect(() => {
    dispatch({
      type: LOAD_ALLAPPLICATIONS_REQUEST,
    });
    dispatch({
      type: LOAD_BUSINESS_REQUEST,
    });
    dispatch({
      type: LOAD_ALLUSER_REQUEST,
    });
  }, []);
  return (
    <div className="currentCnt">
      <p>등록 현황</p>
      <div className="data_box">
        <p>등록된 구직자 수</p>
        <p>{individualCnt} 명</p>
      </div>
      <div className="data_box">
        <p>등록된 구인기업 수</p>
        <p>{businessCnt} 명</p>
      </div>
      <div className="data_box">
        <p>등록된 구인신청 건수</p>
        <p>{applicationCnt} 건</p>
      </div>
      <div className="data_box">
        <p>진행중인 매칭 건수</p>
        <p>{progressCnt} 건</p>
      </div>
      <div className="data_box">
        <p>연간 회원 기업 수</p>
        <p>{yearCnt} 개</p>
      </div>
      <div className="data_box">
        <p>건당 회원 기업 수</p>
        <p>{caseCnt} 개</p>
      </div>
    </div>
  );
};

export default CurrentCnt;
